import Default from './default';
const Breadcrumb = { Default };
export default Breadcrumb;
